import {Component, ElementRef, EventEmitter, Input, Output, Renderer2, ViewChild} from '@angular/core';
import {FaIconComponent} from "@fortawesome/angular-fontawesome";
import {NgbCollapse} from "@ng-bootstrap/ng-bootstrap";
import {FormsModule} from "@angular/forms";


@Component({
    selector: 'app-mobile-search',
    templateUrl: './mobile-search.component.html',
    imports: [
    FaIconComponent,
    NgbCollapse,
    FormsModule
],
    styleUrls: ['./mobile-search.component.css']
})
export class MobileSearchComponent {

  hideMobileSearch = true;
  searchValue = '';
  @ViewChild('mobilesearch') mobilesearch: ElementRef;
  @Output() mobileSearch = new EventEmitter<string>();
  @Input() helper;

  constructor(private renderer: Renderer2) {
  }

  showSearchForMobile(): void {
    this.searchValue = '';
    this.hideMobileSearch = false;
    window.scrollTo({left: 0, top: 0});
    this.renderer.addClass(document.body, 'overflow-hidden');
    setTimeout(() => {
      this.mobilesearch.nativeElement.focus();
      this.mobilesearch.nativeElement.select();
    });
  }

  hideSearchForMobile(): void {
    this.hideMobileSearch = true;
    this.renderer.removeClass(document.body, 'overflow-hidden');
  }

  doSearch(event): boolean {
    event.preventDefault();
    this.mobileSearch.emit(this.searchValue);
    return false;
  }
}
